import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import * as Sentry from '@sentry/browser';

import Nastup from './nastup'; 

class DelkaStudia extends React.Component {
    render() {
        if(this.state.loading) return null;
        return (
            <div>
                <div className="formRow delka-studia">
                    <label>Délka studia:</label> 
                    <select name={`prihlaska[zeme][${this.props.zemeKey}][mesto][${this.props.mestoKey}][skola][${this.props.skolaKey}][kurz][${this.props.kurzKey}][delka]`} onChange={(e) => { this.props.kurz.delkaStudia.value = e.target.value}} value={this.props.kurz.delkaStudia.value} required={this.props.kurzKey === 0 || true}>
                        <option value="">-- Zvolte délku studia --</option>
                        {this.state.delky.map((item, key) => {
                            let weeks = item/7;
                            return <option key={key} value={item}>
                                    {weeks}
                                    {weeks === 1 && "týden"}
                                    {(weeks > 1 && weeks < 5) && "týdny"}
                                    {weeks >= 5 && "týdnů"}
                                </option>
                        })}
                    </select>
                </div>
                {this.props.kurz.delkaStudia.value !== "" &&
                    <Nastup {...this.props} delkaStudia={this.props.kurz.delkaStudia}/>
                }
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = {
            idKurzu: null,
            delky: [],
            loading: true
        }
    }

    componentDidMount() {
        this._load(this.props.kurz.value);
    }

    componentWillReceiveProps(newProps) {
        this._load(newProps.kurz.value);
    }

    _load = (idKurzu) => {
        if(idKurzu === this.state.idKurzu) return;
        this.setState({
            idKurzu: idKurzu,
            delky: [],
            loading: true
        });


        axios.get(this.props.store.apiUrl, {params: {seznam: "delka-studia", idKurzu: idKurzu}})
            .then((response) => {
                this.setState({
                    delky: response.data,
                    loading: false
                });
            })
            .catch((error) => {
                Sentry.captureException(error);
                alert("Došlo k neočekáváné chybě(#A2) při načítání dat. Prosím kontaktujte nás přímo.")
            });
    }

}

export default DelkaStudia;


// WEBPACK FOOTER //
// ./resources/prihlaska/delka-studia.js